/**
 * @ Author: fangjy
 * @ Create Time: 2020-11-09 10:48:29
 * @ Modified by: fangjy
 * @ Modified time: 2020-11-10 14:00:02
 * @ Description: 新点击事件的统一埋点，
 *                变动点：biztype默认传递，而不是从meta中读取
 *                       参数添加默认值和位置变动
 */

/*
 * @ Modified by: zxj
 * @ Modified time: 2021-09-14 14:00:02
 * @ Description: 变动点：方法的调用传参改为单个对象，bizType需主动传递
 */

const isObject = obj =>
  Object.prototype.toString.call(obj) === '[object Object]'

/* 上报事件/页面埋点（兼容[新]单对象调用、与[旧]多参数调用） */
export const newTrackClick = (options, ...rest) => {
  let pageLevelId,
    clickId,
    positionParam,
    pageParam,
    bizType,
    logType,
    positionId
  if (isObject(options)) {
    /* [新]单对象调用的参数获取，biztype默认值改为127 */
    ;({
      pageLevelId,
      clickId,
      positionParam,
      pageParam,
      bizType,
      logType = '20000',
      positionId
    } = options)
  } else {
    /* [旧]多参数调用的参数获取 */
    ;[
      pageLevelId = '',
      clickId,
      positionParam,
      pageParam,
      bizType = '180',
      logType = '20000'
    ] = [options, ...rest]
  }
  pageParam = pageParam ? JSON.stringify(pageParam) : undefined
  positionParam = positionParam ? JSON.stringify(positionParam) : undefined
  try {
    const params = {
      bizType, // 业务类型
      clickId, // 事件编码
      logType, // 上报类型: '10000'页面、'20000'事件
      pageLevelId, // 页面 ID
      pageParam, // 页面参数
      positionId, // 坑位编码
      positionParam // 坑位内容参数
    }
    // console.log(params)
    // 手动上报统一使用单对象参数调用方式，更清晰
    window.track && window.track._launch(params)
  } catch (e) {
    console.error(e)
  }
}

/* 上报页面埋点（兼容[新]单对象调用、与[旧]多参数调用 */
export const newTrackView = (options, ...rest) => {
  let pageLevelId, positionParam, pageParam, bizType, positionId
  if (isObject(options)) {
    /* [新]单对象调用的参数获取 */
    ;({ pageLevelId, positionParam, pageParam, bizType, positionId } = options)
  } else {
    /* [旧]多参数调用的参数获取 */
    ;[pageLevelId = '', positionParam, pageParam] = [options, ...rest]
    bizType = '180'
  }
  const params = {
    bizType,
    logType: '10000',
    pageLevelId,
    pageParam,
    positionParam
  }
  newTrackClick(params)
}
